import { render, staticRenderFns } from "./PdfAndDown.vue?vue&type=template&id=69693600&scoped=true&"
import script from "./PdfAndDown.vue?vue&type=script&lang=js&"
export * from "./PdfAndDown.vue?vue&type=script&lang=js&"
import style0 from "./PdfAndDown.vue?vue&type=style&index=0&id=69693600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69693600",
  null
  
)

export default component.exports